<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select
      v-model="query.siteDeviceId"
      size="small"
      style="width:170px;"
    >
      <el-option
        v-for="site in sites"
        :key="site.siteDevices[0].id"
        :value="site.siteDevices[0].id"
        :label="site.name"
      />
      <!-- <el-option-group
        v-for="site in sites"
        :key="site.id"
        :label="site.name"
      >
        <el-option
          v-for="siteDevice in site.siteDevices"
          :key="siteDevice.id"
          :value="siteDevice.id"
          :label="siteDevice.name"
        />
      </el-option-group> -->
    </el-select>

    <el-button
      :disabled="!query.siteDeviceId"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #filter>
    <section class="chart-option-wrapper">
      <el-input
        v-model="chartOpts.minHeight"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">高度最小值</template>
      </el-input>

      <el-input
        v-model="chartOpts.maxHeight"
        type="number"
        size="small"
        style="width:180px;margin-left:.5em;"
        @change="onChartOptsChanged"
      >
        <template slot="prepend">高度最大值</template>
      </el-input>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <wind-profile-chart-wrapper
        @wind-profile-chart-ready="onWindProfileChartReady"
        @wind-profile-chart-destroy="onWindProfileChartDestroy"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseData from '../../../../BaseData'
import WindProfileChartWrapper from '../../../../../components/Data/ChartWrapper/WindProfileChartWrapper'
import {WIND_PROFILE_CHART_MOVED} from '../../../../../components/Data/Charts/WindProfileChart/EventKeys'
import {
  WIND_PROFILE_DATA_APPEND,
  WIND_PROFILE_DATA_INSERT,
  WIND_PROFILE_DATA_LIST_CHANGED
} from '../../../../../components/Data/ChartWrapper/EventKeys'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import LayoutContent from '../../../../../components/Layout/Content'

export default {
  name: 'DataDisplayWindProfileChart',
  routeInfo: {
    label: '常规',
    icon: 'fa fa-users'
  },
  extends: BaseData,
  components: {LayoutContent, DataWrapper, DataTimeQuery, WindProfileChartWrapper},
  data () {
    let beginTime = new Date()
    beginTime.setDate(beginTime.getDate() - 1)
    return {
      query: {
        beginTime: beginTime.format('YYYY/MM/DD 00:00:00'),
        siteDeviceId: null,
        isAudited: false
      },
      chartOpts: {
        minHeight: 50,
        maxHeight: 2000
      }
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.WIND_PROFILE_CATEGORY
  },
  methods: {
    onWindProfileChartReady (windProfileEb) {
      this.windProfileEb = windProfileEb
      this.windProfileEb.$on(WIND_PROFILE_CHART_MOVED, this[WIND_PROFILE_CHART_MOVED])
    },
    onWindProfileChartDestroy () {
      this.windProfileEb.$off(WIND_PROFILE_CHART_MOVED, this[WIND_PROFILE_CHART_MOVED])
      this.windProfileEb = null
    },
    [WIND_PROFILE_CHART_MOVED] (param) {
      let {dataTimes} = this

      if (dataTimes.length >= 3) {
        return
      }

      let {beginXAxisValue, endXAxisValue, directX} = param
      let {currentQuery} = this

      if (directX > 0) {
        let beginDate = new Date(beginXAxisValue)
        beginDate.setHours(0, 0, 0)

        if (beginDate.getTime() === dataTimes[0].getTime()) {
          let beginTime = new Date(dataTimes[0])
          beginTime.setDate(beginTime.getDate() - 1)
          dataTimes.unshift(beginTime)
          currentQuery.beginTime = beginTime.format('YYYY/MM/DD 00:00:00')
          this.getWindProfileDataCache(beginTime, WIND_PROFILE_DATA_INSERT, 0)
        }
      } else if (directX < 0) {
        let endDate = new Date(endXAxisValue)

        endDate.setHours(0, 0, 0)
        let ts = endDate.getTime()

        if (ts === dataTimes[dataTimes.length - 1].getTime()) {
          let now = new Date()
          now.setHours(0, 0, 0, 0)

          if (ts < now.getTime()) {
            endDate.setDate(endDate.getDate() + 1)
            dataTimes.push(endDate)
            currentQuery.endTime = endDate.format('YYYY/MM/DD 23:59:59')
            this.getWindProfileDataCache(endDate, WIND_PROFILE_DATA_APPEND, 1)
          }
        }
      }
    },
    onSitesChanged () {
      let {query} = this

      if (!query.siteDeviceId) {
        query.siteDeviceId = this.siteDevices[0].id
      }

      this.getWindProfileData()
    },
    getWindProfileData () {
      let {query} = this
      let beginTime = new Date(query.beginTime)
      let endTime = new Date(query.endTime)
      let endTS = endTime.getTime()
      let dataTimes = this.dataTimes = []

      while (beginTime.getTime() <= endTS) {
        dataTimes.push(new Date(beginTime))
        beginTime.setDate(beginTime.getDate() + 1)
      }

      this.changeLoadStatus(true)

      this.$api.Data.getWindProfileData(this.query).then(dataList => {
        this.dataList = Object.freeze(this.getFormatDataList(dataList))
        this.setCurrentQuery()
        this.renderChart()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getFormatDataList (dataList) {
      return dataList.map(data => ({
        dataTime: data.dataTime,
        windSpeeds: data.dasWindSpeedValue.split('|').map(value => value === '' ? null : Number(value)),
        windAngles: data.dasWindDirectionValue.split('|').map(value => value === '' ? null : Number(value))
      }))
    },
    getWindProfileDataCache (dataTime, command, index) {
      let {currentQuery} = this
      let endTime = dataTime.format('YYYY/MM/DD 23:59:59')
      let query = {
        beginTime: dataTime.format('YYYY/MM/DD 00:00:00'),
        endTime,
        siteDeviceId: currentQuery.siteDeviceId,
        isAudited: false
      }

      this.$api.Data.getWindProfileData(query).then(dataList => {
        dataList = this.getFormatDataList(dataList)

        let tmpDataList = new Array(2)
        tmpDataList[index] = dataList
        tmpDataList[index ^ 1] = this.dataList || []

        this.dataList = Object.freeze(tmpDataList.flat())

        this.windProfileEb.$emit(command, {
          beginTime: dataTime,
          endTime: new Date(endTime),
          values: dataList
        })
      }).catch(console.error).finally(() => {
        dataTime = null
        endTime = null
        command = null
      })
    },
    renderChart () {
      let {dataList} = this

      if (!Array.isArray(dataList)) {
        return
      }

      let {currentQuery} = this

      if (!currentQuery) {
        return
      }

      let {chartOpts} = this
      let {
        beginTime,
        endTime,
        siteDevice
      } = this.currentQuery

      beginTime = new Date(beginTime)
      endTime = new Date(endTime)

      for (let key in chartOpts) {
        chartOpts[key] = Number(chartOpts[key])
      }

      this.windProfileEb.$emit(WIND_PROFILE_DATA_LIST_CHANGED, {
        heights: siteDevice.detectionHeights,
        values: dataList,
        dataFrequency: siteDevice.dataFrequency,
        beginTime,
        endTime,
        ...chartOpts
      })
    },
    setCurrentQuery () {
      this.currentQuery = {
        ...this.query,
        siteDevice: this.selectedSiteDevice
      }
    },
    onSearchBtnClick () {
      this.getWindProfileData()
    },
    onChartOptsChanged () {
      this.renderChart()
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  user-select: none;
}

.chart-option-wrapper {
  text-align: center;

  .el-input {
    /deep/ .el-input-group__prepend {
      padding: {
        right: 7px;
        left: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/09WindProfile/01Chart/index.vue